export const PATH = {
  BOOKING_HISTORY_LIST: '/bookingHistory/list',
  BOOKING_HISTORY_FILTERS_DATA: '/bookingHistory/filtersData',
  BOOKING_HISTORY_EXPORT: '/bookingHistory/export',
}
